module.exports = __webpack_public_path__ + "assets/img/302222a9ca7b9ba8ba189ddfa26f904f.svg";